import { render } from "./diagonalBoxInfo.vue?vue&type=template&id=a4ec713c"
import script from "./diagonalBoxInfo.vue?vue&type=script&lang=js"
export * from "./diagonalBoxInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__